function toggleFavorite() {
  let button = $('.card__favorites, .product__favorite');
  button.on('click', function() {
    $(this).toggleClass('active');
  });
}
toggleFavorite();